import { memo } from "react";

import { Box, FormControlLabel, Switch, Typography } from "@mui/material";

import { useStyles } from "./WorkspaceConfigurationPanel.style";
import { getWorkspaceSettingLabels } from "./WorkspaceConfigurationPanel.utils";

type WorkspaceSettingRowProps = {
    name: API.WorkspaceSettingName;
    value: 0 | 1;
    isBusy: boolean;
    reserveLeadingIconSpace?: boolean;
    onToggle: (name: API.WorkspaceSettingName, nextChecked: boolean) => void;
};

const WorkspaceSettingRowComponent = (props: WorkspaceSettingRowProps) => {
    const { name, value, isBusy, reserveLeadingIconSpace, onToggle } = props;
    const { classes } = useStyles();
    const { title: labelTitle, description: labelDescription } = getWorkspaceSettingLabels(name);

    const titleId = `workspace-config-${name}`;
    const checked = value === 1;

    return (
        <Box className={classes.row}>
            <Box className={classes.rowContent} id={titleId}>
                <div className={classes.labelRow}>
                    {reserveLeadingIconSpace ? (
                        <span className={classes.leadingIconSlot} aria-hidden>
                            {name === "MembersRequireTwoFactorAuthentication" ? (
                                <i className={`fa-solid fa-shield-halved ${classes.shieldIcon}`} />
                            ) : null}
                        </span>
                    ) : null}
                    <Typography component="div" className={classes.title} variant="body2">
                        {labelTitle}
                    </Typography>
                </div>
                <Typography className={classes.description} variant="body2" component="p">
                    {labelDescription}
                </Typography>
            </Box>
            <FormControlLabel
                control={
                    <Switch
                        checked={checked}
                        onChange={(_e, nextChecked) => {
                            onToggle(name, nextChecked);
                        }}
                        disabled={isBusy}
                        slotProps={{ input: { "aria-labelledby": titleId } }}
                    />
                }
                label=""
            />
        </Box>
    );
};

export const WorkspaceSettingRow = memo(WorkspaceSettingRowComponent);
